import { Component, EventEmitter, Input, Output } from '@angular/core';

interface TrainingCard {
  id: number;
  image: string;
  text: string;
  date: Date;
}

@Component({
  selector: 'app-card-treinamentos',
  templateUrl: './card-treinamentos.component.html',
  styleUrls: ['./card-treinamentos.component.scss'],
})
export class CardTreinamentosComponent {
  @Output() buttonClick = new EventEmitter<number | null>(null);
  @Input() content: TrainingCard;
}

